import { api, buildUrl } from "./baseApi";
import { addToast } from "../slices/toastSlice";
import getLanguage from "../../utils/getLanguage";

const lang = await getLanguage();

export const distributorApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDistributors: builder.query({
      query: (params) => buildUrl("/distributors", params),
      providesTags: (res) =>
        res
          ? [
              ...res.data.map((o) => ({ type: "Distributors", id: o.id })),
              "Distributors",
            ]
          : ["Distributors"],
    }),
    getDistributorById: builder.query({
      query: (id) => `/distributors/${id}`,
      providesTags: (o) => [{ type: "Distributors", id: o.id }],
    }),
    createDistributor: builder.mutation({
      query: (payload) => ({
        url: `/distributors/create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_res, _err, arg) => [{ type: "Distributors" }],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(
          addToast({
            id: Date.now().toString(),
            message: lang.alert.createSuccess,
            source: "rtkQuery",
            code: 200,
            type: "success",
          })
        );
      },
    }),
    updateDistributor: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/distributors/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Distributors", id: arg.id },
      ],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(
          addToast({
            id: Date.now().toString(),
            message: `Update Distributor ${id} successfully`,
            source: "rtkQuery",
            code: 200,
            type: "success",
          })
        );
      },
    }),
    deleteDistributor: builder.mutation({
      query: (id) => ({
        url: `/distributors/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_res, _err, arg) => [{ type: "Distributors" }],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(
          addToast({
            id: Date.now().toString(),
            message: lang.alert.deleteSuccess,
            source: "rtkQuery",
            code: 200,
            type: "success",
          })
        );
      },
    }),
  }),
});

export const {
  useGetDistributorsQuery,
  useGetDistributorByIdQuery,
  useCreateDistributorMutation,
  useDeleteDistributorMutation,
  useUpdateDistributorMutation,
} = distributorApi;
